<template>
    <div class="home">
        <Header></Header>
        <!-- -->
        <div class="box-principal">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-8 col-lg-4 conteudo-box-principal">
                        <span class="txt-p txt-white">Orientações Técnicas  </span>
                        <p class="txt-p txt-white">
                            Ao contratar esse serviço, a Administração conta com um corpo técnico altamente qualificado para auxiliar na resolução dos mais variados e complexos problemas em matéria de contratação. O serviço de orientação é um suporte valioso na tomada das decisões, porque é totalmente personalizado, atende à situação especifica trazida pelo cliente, por meio da construção de uma solução.
                        </p>
                        <button class="btn btn-roxo w-30" @click="lerMais(1)">Ler mais</button>
                    </div>
                </div>
            </div>
        </div>


        <div class="conheca">
            <div class="container">
                <!-- CONHEÇA -->
                <div class="row">
                    <div class="col-12 col-md-6 pt-4">
                        <span class="txt-p txt-roxo-1 txt-w-4 txt-size-20">Conheça nosso serviço exclusivo de <span class="txt-w-bold txt-size-25">Orientação Técnica</span></span>
                        <p class="txt-p txt-w-4 txt-cores-1 mt-2">
                            O <b>Sollicita Orientações Técnicas</b> é uma ferramenta de conhecimento aplicado, ideal para as suas dúvidas do dia a dia, e problemas mais complexos, que tem por objetivo oferecer suporte, apoio e aconselhamento na área de licitações e contratos.
                        </p>
                        <p class="txt-p txt-w-4 txt-cores-1">
                            Está com alguma dificuldade? Analisamos o seu caso, e oferecemos a solução, com suporte personalizado e material necessário, resultando em um estudo dirigido consultivo, que poderá inclusive ser replicado em outras demandas da instituição.
                        </p>
                        <p class="txt-p txt-w-5 txt-roxo-1 pb-4">
                            Mais segurança para você e para Administração Pública!
                        </p>
                        <button class="btn btn-roxo txt-size-14 px-3" @click="lerMais(2)">
                            LER MAIS A RESPEITO
                        </button>
                    </div>
                    <div class="col-12 col-md-6">
                        <img src="../assets/img/notebook-circle2.png" style="width: 600px; max-width: 100%;" />
                    </div>
                </div>


                <!-- VEJA COMO FUNCIONA -->
                <div class="row mt-6">
                    <div class="col-12 col-md-7 pt-4">
                        <span class="txt-p txt-roxo-1 txt-w-4 txt-size-18 txt-w-bold ">
                            Veja como funciona
                        </span>
                        <p class="txt-p txt-w-4 txt-cores-1 mt-2">
                            Mais do que uma mera manifestação de opinião, tenha acesso a estudos técnicos dirigidos ao atendimento exclusivo da sua demanda, consolidado em conhecimentos sobre a matéria avaliada.
                        </p>
                        <p class="txt-p txt-w-4 txt-cores-1">
                            O <b>Sollicita Orientações Técnicas</b> é uma ferramenta de conhecimento aplicado ideal para as dúvidas do dia a dia e também para seus problemas mais complexos. Por meio de respostas objetivas e dos estudos técnicos, analisamos a sua necessidade com todo o suporte e material necessário, resultando em um estudo dirigido que poderá inclusive ser replicado em outras demandas da Entidade. As orientações são de caráter consultivo acompanhadas da melhor e mais profunda fundamentação.
                        </p>
                        <p class="txt-p txt-w-4 txt-roxo-1">
                            Nosso lema é: <b>saber para resolver!</b>
                        </p>

                    </div>
                    <div class="col-12 col-md-5">
                        <img src="../assets/img/pessoas-circle.png" style="width: 600px; max-width: 100%;" />
                    </div>
                </div>

                <!--MENOR PRAZO DO MERCADO -->
                <div class="row mt-6">
                    <div class="col-12 col-md-6 pe-md-5 d-flex flex-column align-items-end">
                        <span class="txt-p txt-roxo-1 txt-w-bold txt-size-18">
                            Menor prazo do mercado
                        </span>
                        <p class="txt-p txt-w-4 txt-cores-1 mt-2 txt-end w-75">
                            Somente o <b>Sollicita Pró</b> é capaz de oferecer a <b>mais exclusiva orientação técnica e mentoria administrativa, exclusiva, 100% online e ao vivo!</b> Conte com o <b>nosso time</b> sempre que precisar de <b>suporte e apoio para a tomada de decisão!</b> Nossa equipe é preparada para <b>oferecer soluções, em tempo real</b>, nas principais recomendações dos órgãos de controle e na doutrina especializada, <b>no menor prazo do mercado.</b>
                        </p>

                    </div>
                    <div class="col-12 col-md-6 ps-md-5">
                        <img src="../assets/img/relogio.png" style="max-width: 100%;" />
                    </div>
                </div>
            </div>
        </div>

        <!-- TIPOS ORIENTACÕES -->
        <div class="bg-cinza-curvado-convexo">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-6 text-center">
                        <span class="txt-p txt-roxo-1 txt-size-18">
                            Nós possuimos <span class="txt-w-bold txt-size-24">5 tipos</span> de
                        </span>
                        <p class="txt-p txt-roxo-1 txt-w-bold txt-size-24">
                            Orientação Técnica
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="bg-cinza-degrade">
            <div class="container">
                <div class="mx-7" v-for="(item,index) in tiposOrientacoes" :key="index">
                    <div class="row mt-4" v-if="(index%2) == 0">
                        <div class="col-12 col-lg-6 pe-md-5 d-flex justify-content-end">
                            <div class="w-100 d-flex align-items-center justify-content-between">
                                <span class="txt-p txt-size-50 txt-roxo-1 txt-w-bold me-4 txt-line-1">{{index+1}}</span>
                                <span class="txt-p txt-size-25 txt-roxo-1 txt-w-bold txt-end">
                                    {{item.nome}}
                                </span>
                            </div>

                        </div>
                        <div class="col-12 col-lg-6 ps-md-5 d-flex justify-content-start">
                            <img class="img-fluid img-tipos" :src="item.img" />
                        </div>

                    </div>
                    <div class="row mt-4" v-else>
                        <div class="col-12 col-lg-6 pe-md-5 d-flex justify-content-end">
                            <img class="img-fluid img-tipos" :src="item.img" />

                        </div>
                        <div class="col-12 col-lg-6 ps-md-5 d-flex justify-content-start">
                            <div class="w-100 d-flex align-items-center justify-content-between">
                                <span class="txt-p txt-size-25 txt-roxo-1 txt-w-bold txt-left ">
                                    {{item.nome}}
                                </span>
                                <span class="txt-p txt-size-50 txt-roxo-1 txt-w-bold ms-4 txt-line-1">{{index+1}}</span>
                            </div>


                        </div>
                    </div>
                </div>

            </div>
        </div>

        <!-- VAMOS ALEM -->
        <div class="">
            <div class="container">
                <div class="row mt-9">
                    <div class="col-12 col-md-6 pe-md-5 pt-4">
                        <span class="txt-p txt-roxo-1 txt-w-4 txt-size-20">
                            Vamos além: <b>sua dúvida já pode ter sido respondida!</b>
                        </span>
                        <p class="txt-p txt-w-4 txt-cores-1 mt-2">
                            Aqui você tem acesso ao <b>maior acervo</b> de estudos técnicos já emitidos a instituições públicas de todo país. <b>Você poderá ler todas as respostas e estudos técnicos já emitidos pela equipe do Sollicita, que está no mercado há mais de 20 anos</b> realizando orientações administrativas de caráter consultivo para os mais diversos órgãos e instituições e com experiência nos mais variados objetos licitatórios e contratuais, contribuindo para uma Administração Pública mais eficiente. Elas estão disponíveis para consulta na exclusiva ferramenta de Pesquisa do Sollicita Pro.
                        </p>

                        <button class="btn btn-roxo txt-size-14 mt-3 px-3" @click="lerMais(3)">
                            SOLICITE CONTATO AGORA MESMO!
                        </button>

                    </div>
                    <div class="col-12 col-md-6 ps-md-5 mt-5 mt-md-0 d-flex justify-content-end">
                        <img src="../assets/img/lampada-circle.png" class="img-fluid" />
                    </div>
                </div>
            </div>
        </div>

        <!-- DIFERENCIAIS -->
        <div class="">
            <div class="container">
                <div class="mx-7">
                    <div class="row mt-9">
                        <div class="col-12 col-md-6 pe-md-5 d-flex justify-content-end">
                            <div class="w-100 d-flex align-items-center justify-content-between">
                                <span class="txt-p txt-roxo-1 txt-size-20 txt-w-bold">
                                    Diferenciais
                                </span>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-for="(item,index) in diferenciais" :key="index">
            <div class="bg-cinza-degrade-l-r" v-if="index%2 == 0">
                <div class="container">
                    <div class="mx-7">
                        <div class="row" v-if="index%2 == 0">
                            <div class="col-12 col-md-6 pe-md-5">
                                <div class="w-100">
                                    <span class="txt-p txt-roxo-1 txt-size-20 txt-w-bold me-1">{{index+1}}.</span>
                                    <span class="txt-p txt-cores-1" v-html="item"></span>
                                </div>

                            </div>
                            <div class="col-12 col-md-6 ps-md-5">

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="bg-cinza-degrade-r-l" v-else>
                <div class="container">
                    <div class="mx-7">
                        <div class="row">
                            <div class="col-12 col-md-6 pe-md-5">

                            </div>
                            <div class="col-12 col-md-6 ps-md-5">
                                <div class="w-100 txt-end">
                                    <span class="txt-p txt-roxo-1 txt-size-20 txt-w-bold me-1">{{index+1}}.</span>
                                    <span class="txt-p txt-cores-1" v-html="item"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- QUEM UTILIZA -->
        <div class="">
            
            <QuemUtiliza></QuemUtiliza>
        </div>



        <div class="bg-cinza ">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-8 text-center">
                        <p class="txt-p txt-size-20 txt-roxo-1 txt-w-5">Escolha quantas orientações você precisar.</p>
                        <p class="txt-p txt-cores-1 txt-w-4">
                            Atentos as diversas necessidades da Administração Pública oferecemos oito pacotes a sua escolha! E acesso irrestrito a nossa plataforma de pesquisa, capacitação e gestão. Uma customização que apenas o Sollicita oferece.
                        </p>
                        <button class="btn btn-roxo px-4" @click="lerMais(3)">
                            CONHEÇA NOSSOS PLANOS AGORA!
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="bg-cinza">
            <div class="container">
                <Noticias></Noticias>

                <Depoimentos class="mt-6 pb-5"></Depoimentos>

            </div>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import Depoimentos from '@/components/Depoimentos'
    import Noticias from '@/components/Noticias'
    import QuemUtiliza from '@/components/QuemUtiliza'

    import tipoOrientacao1 from '@/assets/img/tpOrientacoes-1.png'
    import tipoOrientacao2 from '@/assets/img/tpOrientacoes-2.png'
    import tipoOrientacao3 from '@/assets/img/tpOrientacoes-3.png'
    import tipoOrientacao4 from '@/assets/img/tpOrientacoes-4.png'
    import tipoOrientacao5 from '@/assets/img/tpOrientacoes-5.png'

    //import { urlApi  } from '@/config/global'
    //import axios from 'axios'

    export default {
        name: 'Home',
        components: { Header, Footer, Depoimentos, Noticias, QuemUtiliza },
        data: function () {
            return {
                tipoOrientacao1,
                tipoOrientacao2,
                tipoOrientacao3,
                tipoOrientacao4,
                tipoOrientacao5,
                                
                tiposOrientacoes: [
                    { nome: 'Contato telefônico', img: tipoOrientacao1},
                    { nome: 'Respostas Objetivas dentro de 04 horas úteis', img: tipoOrientacao2},
                    { nome: 'Estudo técnico dentro de 24 horas úteis', img: tipoOrientacao3},
                    { nome: 'Atendimento WhatsApp dentro de 02 horas úteis', img: tipoOrientacao4},
                    { nome: 'Mentoria online dentro de 48 horas úteis', img: tipoOrientacao5},
                ],

                diferenciais: [
                    "Contar com o <b>suporte de um mentor especializado</b>, qualificado e experiente em licitações e contratos, em qualquer lugar do país, por meio de telefone, whatsapp e videoconferências, além do sistema exclusivo Sollicita, com o app na palma da mão. ",
                    "Ter a <b>garantia da qualidade e tradição da Negócios Públicos</b>, há 20 anos no mercado, aliada ao menor tempo de resposta.",
                    "Ter <b>acesso ao exclusivo programa de Mentoria</b> destinado aos gestores e demais servidores atuantes. A mentoria consiste em uma capacitação interativa em matéria de Licitações e Contratos Administrativos, por meio da exposição dialogada de conteúdo, online e ao vivo, a ser conduzida por um ou mais membros do Corpo Técnico, por meio da plataforma zoom, relativa a temáticas previamente demandadas pelo interessado.",
                    "Acesso ao <b>maior acervo de estudos técnicos e respostas objetivas sobre Licitações e Contratos</b> já publicados pelo nosso corpo técnico. Sua dúvida já pode ter sido respondida e você terá acesso de forma prática e dinâmica.",
                    "E <b>Acessos a maior plataforma de pesquisa, conteúdo</b> (periódicos, matérias e vídeos), Leis Comentadas; Modelos;  eventos gravados com material complementar e ferramentas de gestão (banco de editais, fornecedores, penalidades, analisador de balanços, contador de prazos, agenda, biblioteca) de licitações e contratos.",
                ],

            }
        },

        methods: {
            lerMais(id) {
                switch (id) {
                    case 1:
                        var el = this.$el.getElementsByClassName('conheca')[0];

                        if (el) {
                            el.scrollIntoView({behavior: 'smooth'});
                        }
                        break;

                    case 2:
                        this.$router.push({ name: 'Sistema'})
                        break;

                    case 3:
                        this.$router.push({ name: 'Planos' })
                        break;

                }
                    
            },

        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .home {
        background-color: #ede8ee00;
    }

    .mt-6 {
        margin-top: 6rem;
    }

    .mt-9 {
        margin-top: 9rem;
    }

    .mx-7 {
        margin-left: 10%;
        margin-right: 10%;
    }

    .box-principal {
        background-image: url(../assets/img/home-background-1.svg);
        background-repeat: no-repeat;
        background-position: center; /* Center the image */
        background-repeat: no-repeat; /* Do not repeat the image */
        background-size: cover; /* Resize the background image to cover the entire container */
        background-color: #ede8ee00;
        height: 450px;
    }

    .conteudo-box-principal{
        margin-top: 5%;
    }

    .conteudo-box-principal span{
        font-size: 20px;
    }

    .conteudo-box-principal p{
        font-size: 16px;
        font-weight: 400;
    }

    .bg-cinza {
        background-color: #eeebef;
        padding-top: 6.5rem;
    }

    .bg-cinza-degrade {
        background: linear-gradient(0deg, rgba(237, 232, 238, 0) 0%, #EDE8EEBA 77.31%);
        padding-top: 1rem;
    }

    .bg-cinza-degrade-r-l {
        background: linear-gradient(270deg, rgba(237, 232, 238, 0) 0%, #EDE8EE 77.31%);
        padding: 20px 0;
    }

    .bg-cinza-degrade-l-r {
        background: linear-gradient(90deg, rgba(237, 232, 238, 0) 0%, #EDE8EE 77.31%);
        padding: 20px 0;
    }

    .bg-cinza-curvado-convexo {
        background-image: url(../assets/img/retangulo-curvado-home-convexo.png);
        padding-top: 3rem;
        margin-top: 5rem;
        /*background-color: #E5E5E5;*/
        background-repeat: no-repeat;
        background-position: top;
    }

    .bg-cinza-curvado-concavo {
        background-image: url(../assets/img/retangulo-curvado-home.png);
        padding-top: 12rem;
        margin-top: 1rem;
        /*background-color: #E5E5E5;*/
        background-repeat: no-repeat;
        background-position: top;
    }

    .img-tipos {
        max-height: 120px;
    }
</style>

